export enum Role {
    User = 'user',
    Actuator = 'actuator',
    Curator = 'curator',
    Admin = 'admin'
}